var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 8.33411C10.0982 8.33411 9.10997 8.67636 8.41119 9.38132C7.71425 10.0826 7.375 11.0796 7.375 12.0542V32.515C7.375 37.7046 10.4209 42.0329 14.75 44.7802V52.9757H42.4062V44.7802C46.7354 42.0329 49.7812 37.7027 49.7812 32.515V30.6549H25.8125V12.0542C25.8125 11.0814 25.4733 10.0844 24.7745 9.37946C24.0794 8.67636 23.0911 8.33411 22.125 8.33411H11.0625ZM11.0625 12.0542H22.125V30.6549H11.0625V12.0542ZM14.75 15.7744V21.3546H18.4375V15.7744H14.75ZM11.6377 34.375H45.5167C44.8621 37.5874 42.9963 40.4203 39.6978 42.2227L38.7188 42.7453V49.2556H18.4375V42.7453L17.4585 42.2227C14.1582 40.4203 12.2941 37.5874 11.6396 34.375H11.6377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaToilet);
export default __webpack_public_path__ + "static/media/la_toilet.8e8859d6ddc345e6f3d260cc0684a688.svg";
export { ForwardRef as ReactComponent };